<template>
  <parent>
    <loading-page v-if="loading" />

    <div
      v-else
      class="cache-policies-info h-100"
    >
      <form-wrapper full-width>
        <template v-slot:body>
          <paper>
            <template v-slot:title>
              <p class="mb-0">
                Info
              </p>
            </template>
            <div class="px-2 col-12 col-lg-6 m-auto">
              <div class="information">
                <label>Name</label>
                <p class="text-main text-thick">
                  {{ cachePolicy.name || '-' }}
                </p>
              </div>
              <div class="information">
                <label>Comment</label>
                <p class="text-main text-thick">
                  {{ cachePolicy.comment || '-' }}
                </p>
              </div>
            </div>
          </paper>

          <paper>
            <template v-slot:title>
              <p class="mb-0">
                TTL Settings
              </p>
            </template>
            <div class="d-flex flex-wrap align-items-stretch col-12 col-lg-6 m-auto pb-4">
              <div class="col-12 col-lg-6 m-auto">
                <h6 class="text-main">
                  Server TTL Settings
                </h6>
                <div class="information">
                  <label>Minimum TTL</label>
                  <p class="text-main text-thick">
                    {{ cachePolicy.minimumTTL }}
                  </p>
                </div>
                <div class="information">
                  <label>Maximum TTL</label>
                  <p class="text-main text-thick">
                    {{ cachePolicy.maximumTTL }}
                  </p>
                </div>
                <div class="information mb-4">
                  <label>Default TTL</label>
                  <p class="text-main text-thick">
                    {{ cachePolicy.defaultTTL }}
                  </p>
                </div>
              </div>
              <div class="col-12 col-lg-6 m-auto">
                <h6 class="text-main">
                  Browser TTL Settings
                </h6>
                <div class="information">
                  <label>Browser Minimum TTL</label>
                  <p class="text-main text-thick">
                    {{ cachePolicy.browserMinimumTTL }}
                  </p>
                </div>
                <div class="information">
                  <label>Browser Maximum  TTL</label>
                  <p class="text-main text-thick">
                    {{ cachePolicy.browserMaximumTTL }}
                  </p>
                </div>
                <div class="information">
                  <label>Browser Default TTL</label>
                  <p class="text-main text-thick">
                    {{ cachePolicy.browserDefaultTTL }}
                  </p>
                </div>
                <div class="d-flex">
                  <b-form-checkbox
                    v-model="cachePolicy.addBrowserCache"
                    switch
                    disabled
                  />
                  <span class="mt-1">Browser cache</span>
                </div>

              </div>
            </div>

          </paper>

          <paper>
            <template v-slot:title>
              <div>
                <p>Cache key contents</p>
                <span
                  class="text-regular"
                >The cache key includes the headers, cookies, and query
                  strings in the cache policy, as follows:</span>
              </div>
            </template>
            <div class="px-2 col-12 col-lg-6 m-auto">
              <div class="d-flex">
                <div class="information w-50">
                  <label>Headers</label>
                  <p class="text-main text-thick">
                    {{ header }}
                  </p>
                  <div
                    v-if="header && headers.length > 0"
                    class="mb-1"
                  >
                    <template v-for="head in headers">
                      <span
                        :key="head"
                        class="custom-tags"
                      > {{ head }} </span>
                    </template>
                  </div>
                </div>

                <div class="information w-50">
                  <label>Cookies</label>
                  <p class="text-main text-thick">
                    {{ cookie }}
                  </p>
                  <div
                    v-if="cookies && cookies.length > 0"
                    class="mb-1"
                  >
                    <template v-for="cook in cookies">
                      <span
                        :key="cook"
                        class="custom-tags"
                      > {{ cook }} </span>
                    </template>
                  </div>
                </div>
              </div>

              <div class="d-flex">
                <div class="information w-50">
                  <label>Query strings</label>
                  <p class="text-main text-thick">
                    {{ queryString }}
                  </p>
                  <div
                    v-if="queryStrings && queryStrings.length > 0"
                    class="mb-1"
                  >
                    <template v-for="query in queryStrings">
                      <span
                        :key="query"
                        class="custom-tags"
                      >
                        {{ query }}
                      </span>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </paper>
        </template>

        <template v-slot:footer>
          <b-button
            v-if="goBack"
            variant="bg-white"
            @click="onGoBack()"
          >
            Go Back
          </b-button>
        </template>
      </form-wrapper>
    </div>
  </parent>
</template>
<script>
import Paper from '@/components/paper/Paper.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'CachePoliciesInfo',
  components: {
    Paper,
  },
  data() {
    return {
      policyId: null,
      goBack: false,
    }
  },
  computed: {
    cachePolicy() {
      return this.$store.state.cachePolicies.cachePolicy
    },
    header() {
      const header = this.cachePolicy?.headerOptions?.findIndex(
        x => x.id === this.cachePolicy.headerPolicyId,
      )
      return this.cachePolicy?.headerOptions?.[header]?.value ?? null
    },
    cookie() {
      const cookie = this.cachePolicy?.cookieOptions?.findIndex(
        x => x.id === this.cachePolicy?.cookiePolicyId,
      )
      return this.cachePolicy?.cookieOptions?.[cookie]?.value ?? null
    },
    queryString() {
      const queryString = this.cachePolicy?.queryStringOptions?.findIndex(
        x => x.id === this.cachePolicy?.queryStringPolicyId,
      )
      return this.cachePolicy?.queryStringOptions?.[queryString]?.value ?? null
    },

    loading() {
      return this.$store.state.cachePolicies.gettingPolicy
    },
    cookies() {
      return this.cachePolicy.cookies
    },
    headers() {
      return this.cachePolicy.headers
    },
    queryStrings() {
      return this.cachePolicy.queryStrings
    },
  },
  created() {
    this.policyId = this.$route.params.cacheId
    this.$store
      .dispatch('cachePolicies/getCachePolicy', this.policyId)
      .catch(err => redirectError(err, this.$router, this.$route.path))
    this.goBack = this.$route.query.v !== undefined
  },
  methods: {
    onGoBack() {
      this.$router.push({ name: 'cache-policies' })
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-tags {
  border: 1px solid #e0e5eb;
  padding: 12px;
  margin: 0 5px 5px 0;
  display: inline-flex;
  word-break: break-all;
}
</style>
